import { Route, Routes } from '@angular/router';

import { buildRoutesByFeatureFlags, FeatureFlag } from '@models/feature-flag.model';

import { ROUTING_PATH } from '@shared/constants/routingPath';
import { CanDeactivateGuard } from '@shared/guards/can-deactivate.guard';
import { Flags } from '@shared/services/launch-darkly.service';

import { AccountComponent } from './account.component';
import { AccountNotificationsComponent } from './tabs/account-notifications/account-notifications.component';
import { AccountSettingsComponent } from './tabs/account-settings/account-settings.component';

export const ACCOUNT_ROUTES_FF: Routes = [
  {
    component: AccountSettingsComponent,
    data: {
      feature: FeatureFlag.ACCOUNT_SETTINGS,
    },
    path: ROUTING_PATH.ACCOUNT.SETTINGS,
  },
];

export const buildAccountRoutes = (featureFlags: Flags | null): Route => {
  const enabledRoutes: Routes = [
    {
      canDeactivate: [CanDeactivateGuard],
      component: AccountNotificationsComponent,
      path: ROUTING_PATH.ACCOUNT.NOTIFICATIONS,
    },
    ...buildRoutesByFeatureFlags(featureFlags, ACCOUNT_ROUTES_FF),
  ];

  return {
    children: [...enabledRoutes, { path: '**', redirectTo: ROUTING_PATH.ACCOUNT.NOTIFICATIONS }],
    component: AccountComponent,
    path: ROUTING_PATH.ACCOUNT.INDEX,
  };
};
